/** Pantalla de espera o de aviso a página completa. */
export function FullScreenMessage({ text }: { text: string }) {
  return (
    <div
      className="grid min-h-dvh place-items-center p-4 text-center text-tenue"
      role="status"
      aria-live="polite"
      data-test="pantalla-mensaje"
    >
      <p>{text}</p>
    </div>
  );
}

/** Espera dentro de una pantalla, sin ocupar toda la ventana. */
export function Cargando({ text }: { text: string }) {
  return (
    <p className="py-8 text-center text-tenue" role="status" aria-live="polite" data-test="cargando">
      {text}
    </p>
  );
}
